import React, { useState, createContext } from "react";

export const FormContext = createContext();

export const FormProvider = (props) => {
  const [form, setForm] = useState({
    count: 0,
    email: "",
    gender: "",
    type: "",
    militaryStatus: "",
    exerciseFrequency: "",
    profession: "",
    professionArray: [],
    sportType: "",
    sportsPlayed: "",
    stress: 0,
    irritability: 0,
    anxiety: 0,
    energy: 0,
    alcohol: "",
    tobacco: "",
    cannabis: "",
    recreationalDrugs: "",
    hoursSitting: 0,
    sleepRating: 0,
    dailyRoutine: 0,
    hoursSleep: 8,
    neurodiversities: [],
    imperial: {
      feet: 5,
      inches: 9,
      lbs: 165,
    },
    metric: {
      cm: 175,
      kg: 60,
    },
    height: "",
    otherNeurodiversities: "",
    weight: "",
    concussionNumber: "0",
    concussionHistory: "",
    dob: "",
  });
  return (
    <FormContext.Provider value={[form, setForm]}>
      {props.children}
    </FormContext.Provider>
  );
};
